import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import styled from '@emotion/styled';
import { colors, defaultFontFamily as defaultFont, } from '@modernhealth/vital-foundation';
import { pxToRem } from '../../helpers/pxToRem';
import { ColorVariant } from './ColorVariant';
import { OutlinedLabel } from './OutlinedLabel';
// Helper text
const HelpText = styled.div(({ variant }) => {
    let color = '';
    switch (variant) {
        case ColorVariant.Error:
            color = colors.red55;
            break;
        default:
            color = colors.gray55;
    }
    return {
        paddingTop: pxToRem(4),
        paddingLeft: pxToRem(8),
        textAlign: 'left',
        color,
        fontFamily: defaultFont,
        fontWeight: 400,
        fontSize: pxToRem(14),
        lineHeight: pxToRem(20),
    };
});
// General input container
const InputContainer = styled.div({ position: 'relative', width: '100%' });
const Name = 'InputField';
/**
 * A wrapper which handles form field labels, accessibility hook ups, and styling.
 * @deprecated
 */
export const InputField = ({ fieldId, renderInput, error, helpText, rightPadding, value, initialValue, useDefaultPlaceholder, 
// Don't pass children...
// eslint-disable-next-line @typescript-eslint/no-unused-vars
children, label, labelledBy, }) => {
    const [isActive, setIsActive] = useState(false);
    // isFilled tracks whether "value" exists in controlled input
    const [isFilled, setIsFilled] = useState(false);
    // isFloatingLabelFixed tracks whether "initialValue" was set in uncontrolled input
    const [isFloatingLabelFixed, setIsFloatingLabelFixed] = useState(!!initialValue);
    const onUnfocus = () => {
        setIsActive(false);
    };
    const onFocus = () => {
        setIsActive(true);
    };
    let colorVariant;
    if (!!error) {
        colorVariant = ColorVariant.Error;
    }
    else if (isActive) {
        colorVariant = ColorVariant.Active;
    }
    else {
        colorVariant = ColorVariant.Default;
    }
    const hasLabel = !!label;
    const shouldRenderFloatingLabel = hasLabel && !labelledBy && !useDefaultPlaceholder;
    const labelId = shouldRenderFloatingLabel ? `${fieldId}--Label` : labelledBy;
    const helpId = `${fieldId}--HelpText`;
    const inputId = `${fieldId}--InputField`;
    const isHelpTextVisible = !!error || !!helpText;
    return (_jsxs(InputContainer, { id: fieldId, "data-component": Name, children: [shouldRenderFloatingLabel && labelId ? (_jsx(OutlinedLabel, { id: labelId, label: label, active: isActive, rightPadding: rightPadding, floatingLabelFixed: isFloatingLabelFixed, filled: !!value || isFilled, variant: colorVariant })) : null, renderInput({
                onFocus,
                onUnfocus,
                setIsFilled,
                setIsFloatingLabelFixed,
                isFilled,
                variant: colorVariant,
                labelId,
                helpId,
                inputId,
            }), isHelpTextVisible && (_jsx(HelpText, { id: helpId, variant: colorVariant, children: error || helpText }))] }));
};
